/** 모달 ALERT **/
import TERMS from '@/components/common/modal/alert/terms/index'
import WITHDRAW from '@/components/common/modal/alert/withdraw/index'
import CONFIRM from '@/components/common/modal/alert/confirm/index'

/** 모달 **/
import OFFLINECLIENT from '@/components/common/modal/form/offline-client/index'
import PASSWORD from '@/components/common/modal/password/index'

/** 페이지네이션 */
import BasePagination from '@/components/common/layouts/pagination/index'

export const modalAlertNames = {
  TERMS,
  WITHDRAW,
  CONFIRM
}

export const modalNames = {
  OFFLINECLIENT,
  PASSWORD
}

export const globalComponentNames = {
  BasePagination
}
